import { render } from "./ContentPane.vue?vue&type=template&id=67596653"
import script from "./ContentPane.vue?vue&type=script&lang=js"
export * from "./ContentPane.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__